import { MouseEventHandler } from "react";

export default function Profile({
  size = 50,
  alt,
  onClick
}: {
  size?: number;
  alt?: string;
  onClick?: MouseEventHandler<SVGSVGElement>;
}) {
  return (
    <svg
      stroke="var(--thirty)"
      fill="var(--thirty)"
      strokeWidth="1"
      viewBox="0 0 24 24"
      height={`${size}px`}
      width={`${size}px`}
      xmlns="http://www.w3.org/2000/svg"
      xlinkTitle={alt}
      onClick={onClick}
      style={onClick ? { cursor: "pointer" } : {}}
    >
      <g>
        <path
          d="M9.096 5.257 C9.096 5.257, 9.096 5.257, 9.096 5.257 M9.096 5.257 C9.096 5.257, 9.096 5.257, 9.096 5.257 M8.669 8.734 C10.215 7.006, 11.793 5.404, 12.666 4.462 M8.529 8.696 C10.167 7.09, 11.466 5.719, 12.696 4.288 M9.127 10.942 C10.857 9.459, 12.165 7.986, 14.994 4.587 M9.557 10.819 C11.063 8.996, 12.84 7.087, 14.62 5.03 M4.371 19.788 C4.763 19.188, 5.32 18.965, 6.423 17.447 M4.373 19.732 C4.892 19.255, 5.346 18.676, 6.46 17.567 M11.927 11.21 C13.314 9.514, 14.441 7.912, 16.099 6.433 M11.598 11.408 C13.066 9.719, 14.552 8.068, 16.196 6.157 M6.745 20.689 C7.827 18.479, 9.279 17.045, 11.787 14.032 M6.761 20.283 C8.274 18.394, 10.26 16.13, 11.668 14.388 M9.4 19.869 C10.602 19.138, 11.204 17.555, 14.269 14.563 M9.519 20.147 C10.946 18.223, 12.601 16.343, 14.011 15.006 M12.177 20.156 C13.61 18.225, 14.958 16.741, 16.074 15.127 M12.357 19.955 C13.719 18.278, 15.173 16.397, 16.21 15.248 M14.135 20.276 C15.431 19.282, 16.235 18.165, 18.143 15.872 M14.536 20.581 C15.945 18.837, 17.389 16.897, 18.423 15.969 M17.242 20.173 C17.897 19.592, 18.415 18.791, 19.889 17.124 M17.279 20.343 C17.926 19.648, 18.474 18.823, 19.889 17.317"
          stroke="var(--thirty)"
          strokeOpacity="0.5"
          strokeWidth="1"
          fill="none"
        ></path>
        <path
          d="M11.412 12.725 M12 12 C14.726 12.616, 16.769 9.821, 15.375 8.563 M12.939 11.354 C15.02 12.967, 16.9 10.894, 15.341 7.505 M16 8 C16.479 6.556, 13.38 4.693, 11.256 4.818 M15.623 7.543 C16.782 6.42, 15.184 4.543, 12.821 5.134 M12 4 C10.485 4.559, 8.501 5.235, 7.991 7.345 M11.544 3.284 C10.385 4.939, 8.276 5.343, 7.724 8.949 M8 8 C7.495 11.184, 9.037 12.912, 11.581 12.367 M7.035 7.695 C8.8 9.77, 10.492 12.67, 12.702 12.384 M12.892 13.514 M12 14 C9.663 14.844, 3.491 14.923, 3.165 18.86 M12.895 13.782 C8.332 14.574, 4.806 15.041, 4.598 17.608 M3.998 17.994 C4 18.788, 3.994 19.499, 4.009 19.995 M3.994 18.035 C3.968 18.711, 4.016 19.388, 4.027 20.017 M4.22 19.992 C7.42 19.645, 10.382 19.274, 20.346 19.239 M4.048 20.062 C9.175 19.811, 14.598 19.984, 19.86 19.814 M20.007 19.929 C19.943 19.49, 19.964 19.223, 19.924 18.029 M20.034 19.962 C19.992 19.505, 20 18.9, 20.047 18.049 M20 18 C20.266 14.751, 14.521 13.103, 12.107 13.383 M19.422 18.041 C19.926 14.477, 14.914 13.877, 11.258 13.179"
          fill="none"
        ></path>
      </g>
    </svg>
  );
}
